if (!customElements.get('piex-clown-video')) {
  customElements.define('piex-clown-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.slide = this.closest('.swiper-slide');
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userPaused = false;
      this.manual = false;
      this.loaded = false;
      this.failed = false;
      this.video.muted = true;
      this.button.hidden = false;
      const options = {signal: this.abort.signal};
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        this.manual = !this.userPaused;
        this.sync();
      }, options);
      this.video.addEventListener('playing', () => { this.dataset.ready = 'true'; this.label(); }, options);
      this.video.addEventListener('pause', () => this.label(), options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.removeAttribute('data-ready');
        this.button.hidden = true;
        this.video.pause();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { this.manual = false; this.sync(); }, options);
      this.modeObserver = new MutationObserver(() => this.sync());
      this.modeObserver.observe(document.documentElement, {attributes:true, attributeFilter:['data-piex-mode']});
      this.slideObserver = new MutationObserver(() => this.sync());
      this.slideObserver.observe(this.slide, {attributes:true, attributeFilter:['class','aria-hidden','inert']});
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, {threshold:0.05});
      this.intersection.observe(this);
    }
    shouldPlay() {
      return this.isConnected && !this.failed && this.visible && !document.hidden &&
        document.documentElement.dataset.piexMode === 'halloween' &&
        this.slide.classList.contains('swiper-slide-active') && this.slide.getAttribute('aria-hidden') !== 'true' &&
        !this.userPaused && (!this.motion.matches || this.manual) && (this.dataset.editor !== 'true' || this.manual);
    }
    sync() {
      if (!this.shouldPlay()) { this.video.pause(); this.label(); return; }
      if (!this.loaded) {
        if (navigator.connection && navigator.connection.saveData && !this.manual) {
          this.video.pause(); this.label(); return;
        }
        if (document.readyState !== 'complete' && !this.manual && !this.waitOver) {
          if (!this.waitingLoad) {
            this.waitingLoad = true;
            const go = () => { if (this.waitOver) return; this.waitOver = true; this.sync(); };
            window.addEventListener('load', go, {once: true, signal: this.abort.signal});
            setTimeout(go, 3000); // Piex (v9d): como mucho 3 segundos de espera aunque una aplicacion retrase el evento load
          }
          this.video.pause(); this.label(); return;
        }
        this.video.src = this.video.dataset.src;
        this.loaded = true;
        this.video.load();
      }
      this.video.play().then(() => {
        if (!this.shouldPlay()) this.video.pause();
        this.label();
      }).catch(() => this.label());
    }
    label() {
      this.button.textContent = this.video.paused ? 'Reproducir' : 'Pausar';
      this.button.setAttribute('aria-label', this.video.paused ? 'Reproducir vídeo del payaso' : 'Pausar vídeo del payaso');
    }
    disconnectedCallback() {
      this.video?.pause();
      this.abort?.abort();
      this.modeObserver?.disconnect();
      this.slideObserver?.disconnect();
      this.intersection?.disconnect();
    }
  });
}
